<template>
  <TaoCanBo isEdit/>
</template>

<script>
import TaoCanBo from "@/components/pages/quan-ly-danh-muc/can-bo/TaoCanBo"

export default {
  name: "SuaCanBo",
  components: {
    TaoCanBo
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.mx-datepicker.is-danger {
  :focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgb(220 53 69 / 25%);
  }
  input {
    border: 1px solid #e42020;
  }
}
.error {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  margin-bottom: 0;
}
.mx-datepicker {
  width: 100% !important;
  .mx-input {
    border-radius: 3px !important;
  }
}
</style>
